import React from 'react';
import { Table } from 'antd';

export const LCTable = props => <Table {...props} />;